// extracted by mini-css-extract-plugin
export default {"wrap":"Links_wrap__OA3PC","btn":"Links_btn__s1AQk"};